import { Result } from "../../models/result";

export function sortSizeDescending(a: Result, b: Result) {
	if (a === undefined || b === undefined) {
		return 0;
	}

	if (a.size[1] < b.size[1]) {
		return 1;
	}
	if (a.size[1] > b.size[1]) {
		return -1;
	}

	return 0;
}
